module.exports = __webpack_public_path__ + "static/media/Hbook-06.633f9f6e.jpg";